import React from 'react';
import { Navigate } from 'react-router';

import baseRoutes from 'common/shared-ui/src/appInitializer/baseRoutes';
import ObjectsHierarchy from 'components/administration/objectsHierarchy/ObjectsHierarchy';
import TimesheetsSettings from 'components/administration/timesheetsSettings/TimesheetsSettings';
import DashboardLayout from 'components/dashboard/DashboardLayout';

import ActivityContainer from '../activity/ActivityContainer';
import AdministrationContainer from '../administration/AdministrationContainer';
import Art from '../administration/art/Art';
import CalculationTypes from '../administration/calculationTypes/CalculationTypes';
import Competency from '../administration/competency/Competency';
import ConfirmationPage from '../administration/confirmationPage/ConfirmationPage';
import ConfirmationSettings from '../administration/confirmationSettings/ConfirmationSettings';
import ContractStagesContainer from '../administration/contractStages/ContractStagesContainer';
import GanttSettings from '../administration/ganttSettings/GanttSettings';
import ImportNewData from '../administration/importNewData/ImportNewData';
import ProdCalendarContainer from '../administration/productionCalendar/ProdCalendarContainer';
import UserPage from '../administration/userPage/UserPage';
import UsersList from '../administration/users/UsersList';
import AgileContainer from '../agile/AgileContainer';
import ArtContainer from '../art/ArtContainer';
import AuthContainer from '../auth/AuthContainer';
import ConfirmationsPage from '../confirmations/ConfirmationsPage';
import Departments from '../departments/Departments';
import GanttContainer from '../gantt/GanttContainer';
import IssueCreateEdit from '../issueCreateEdit/IssueCreateEdit';
import IssuePage from '../issuePage/IssuePage';
import IssuesContainer from '../issues/IssuesContainer';
import LogoutContainer from '../logout/LogoutContainer';
import MyPage from '../myPage/myPage';
import ProjectCreateEdit from '../projectCreateEdit/ProjectCreateEdit';
import ProjectPage from '../projects/ProjectPage';
import ProjectReports from '../projects/ProjectReports';
import ProjectsContainer from '../projects/ProjectsContainer';
import ProjectsSettings from '../projectsSettings/ProjectsSettings';
import ResourcePlanContainer from '../resourcePlan/ResourcePlanContainer';
import ResplanSettingsContainer from '../resplanSettings/ResplanSettingsContainer';
import SettingsContainer from '../settings/SettingsContainer';
import SpentTimeContainer from '../spentTime/SpentTimeContainer';
import SpreadsheetContainer from '../spreadsheet/SpreadsheetContainer/SpreadsheetContainer';

import RedirectRouter from './Router';

export default [
  ...baseRoutes,
  {
    path: '/login',
    element: <AuthContainer />,
  },
  {
    path: '/logout',
    element: <LogoutContainer />,
  },
  {
    path: '/router',
    element: <RedirectRouter />,
  },
  {
    path: '/',
    exact: true,
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <Navigate to='/projects' />,
      },
      {
        path: '/projects',
        children: [
          {
            index: true,
            element: <ProjectsContainer />,
          },
          {
            path: 'query/:queryId',
            element: <ProjectsContainer />,
          },
          {
            path: ':projectId',
            children: [
              {
                index: true,
                element: <ProjectPage />,
              },
              {
                path: 'edit',
                element: <ProjectCreateEdit />,
              },
            ],
          },
          {
            path: 'create',
            element: <ProjectCreateEdit />,
          },
        ],
      },
      {
        path: '/projects-settings',
        element: <ProjectsSettings />,
      },
      {
        path: '/activity',
        element: <ActivityContainer />,
      },
      {
        path: '/issues',
        children: [
          {
            index: true,
            element: <IssuesContainer />,
          },
          {
            path: 'query/:queryId',
            element: <IssuesContainer />,
          },
        ],
      },
      {
        path: '/projects/:projectId/issues',
        children: [
          {
            index: true,
            element: <IssuesContainer />,
          },
          {
            path: 'query/:queryId',
            element: <IssuesContainer />,
          },
        ],
      },
      {
        path: '/issues/create',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: '/projects/:projectId/issues/create',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: '/issues/:parentId/create',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: '/projects/:projectId/issues/:parentId/create',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: '/issues/:copyId/copy',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: 'projects/:projectId/issues/:copyId/copy',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: 'issues/:id/edit',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: 'projects/:projectId/issues/:id/edit',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: 'issues/bulk_edit',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: 'projects/:projectId/issues/bulk_edit',
        element: <IssueCreateEdit></IssueCreateEdit>,
      },
      {
        path: 'issues/:id',
        element: <IssuePage />,
      },
      {
        path: 'projects/:projectId/issues/:id',
        element: <IssuePage />,
      },
      {
        path: '/timesheets',
        children: [
          {
            index: true,
            element: <SpentTimeContainer />,
          },
          {
            path: 'query/:queryId',
            element: <SpentTimeContainer />,
          },
        ],
      },
      {
        path: '/projects/:projectId/timesheets',
        children: [
          {
            index: true,
            element: <SpentTimeContainer />,
          },
          {
            path: 'query/:queryId',
            element: <SpentTimeContainer />,
          },
        ],
      },
      {
        path: '/gantt',
        element: <GanttContainer />,
      },
      {
        path: '/projects/:projectId/gantt',
        element: <GanttContainer />,
      },
      {
        path: '/finances',
        children: [
          {
            index: true,
            element: <ArtContainer />,
          },
          {
            path: 'query/:queryId',
            element: <ArtContainer />,
          },
        ],
      },
      {
        path: '/spreadsheet',
        element: <SpreadsheetContainer />,
      },
      {
        path: '/resourcePlan',
        element: <ResourcePlanContainer />,
      },
      {
        path: '/agile',
        children: [
          {
            index: true,
            element: <AgileContainer />,
          },
          {
            path: 'query/:queryId',
            element: <AgileContainer />,
          },
        ],
      },
      {
        path: '/projects/:projectId/agile',
        element: <AgileContainer />,
      },
      {
        path: '/projects/:projectId/agile/query/:queryId',
        element: <AgileContainer />,
      },
      {
        path: '/my/account',
        element: <SettingsContainer />,
      },
      {
        path: '/my',
        element: <MyPage />,
      },
      {
        path: '/administration',
        children: [
          {
            index: true,
            element: <AdministrationContainer />,
          },
          {
            path: 'projects',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'users',
            element: <UsersList />,
          },
          {
            path: 'users/:id',
            element: <UserPage />,
          },
          {
            path: 'users/:id/edit',
            element: <UserPage />,
          },
          {
            path: 'groups',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'permissions',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'trackers',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'issue-statuses',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'workflows',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'custom-fields',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'enumerations',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'project-reports',
            element: <ProjectReports />,
          },
          {
            path: 'production-calendar',
            element: <ProdCalendarContainer />,
          },
          {
            path: 'settings',
            element: <>EMPTY PAGE</>,
          },
          {
            path: 'resourcePlan-settings',
            element: <ResplanSettingsContainer />,
          },
          {
            path: 'calculation-types',
            element: <CalculationTypes />,
          },
          {
            path: 'contract-stages',
            element: <ContractStagesContainer />,
          },
          {
            path: 'confirmation-settings',
            element: <ConfirmationSettings />,
          },
          {
            path: 'gantt-settings',
            element: <GanttSettings />,
          },
          {
            path: 'import',
            element: <ImportNewData />,
          },
          {
            path: 'art-settings',
            element: <Art />,
          },
          {
            path: 'competency',
            element: <Competency />,
          },
          {
            path: 'departments',
            element: <Departments />,
          },
          {
            path: 'objects-hierarchy',
            element: <ObjectsHierarchy />,
          },
          {
            path: 'timesheets-settings',
            element: <TimesheetsSettings />,
          },
        ],
      },
      {
        path: 'confirmation/reinit',
        element: <ConfirmationPage />,
      },
      {
        path: 'confirmations/:id',
        element: <ConfirmationPage />,
      },
      {
        path: '/projects/:projectId/confirmations/:id',
        element: <ConfirmationPage />,
      },
      {
        path: 'confirmations',
        element: <ConfirmationsPage></ConfirmationsPage>,
      },
      {
        path: '/projects/:projectId/confirmations',
        element: <ConfirmationsPage></ConfirmationsPage>,
      },
      {
        path: '/projects/:projectId/confirmations/query/:queryId',
        element: <ConfirmationsPage></ConfirmationsPage>,
      },
      {
        path: 'confirmations/query/:queryId',
        element: <ConfirmationsPage></ConfirmationsPage>,
      },
      { path: '*', element: <Navigate to='/errors/error-404' /> },
    ],
  },
];
